import AddressWithVerification from './AddressWithVerification';

export default AddressWithVerification;
